import { INetworkResult } from '@/coreDomainsModule/networkResult';
import {
  UpdateBusinessForInputValuesApi,
  UpdateBusinessForInputValuesPostRequest,
  UpdateBusinessForInputValuesResponseResult,
} from '../axios/generated/registerBusinessManage/api';
import { customAxiosInstance } from '../axios/axiosInstance';
import { IError } from '../interfaces/IError';
import { axiosErrorHandler } from '../axios/axiosError';
import { IUpdateRegisterBusinessRepository } from '../interfaces/IUpdateRegisterBusinessRepository';
import { pollAsyncProcess } from '../composables/useAsyncPolling';
import { gzipRequestOptions } from '../axios/gzipRequestInterceptor';

/**
 * Axiosを使ったリポジトリ実装例
 */
export class UpdateRegisterBusinessRepository implements IUpdateRegisterBusinessRepository {
  /**
   * 集計情報の登録
   * とりあえず、bulkは考えず単体の1取引分の情報をputする
   * @param updateBusinessForInputValuesRequest - 更新するビジネス情報
   */
  async put(
    updateBusinessForInputValuesRequest: UpdateBusinessForInputValuesPostRequest
  ): Promise<INetworkResult<UpdateBusinessForInputValuesResponseResult, IError>> {
    const axiosInstance = await customAxiosInstance('dbAccess');
    const updateBusinessForInputValuesApi = new UpdateBusinessForInputValuesApi(undefined, undefined, axiosInstance);

    // APIを叩く
    try {
      const apiResponse = await updateBusinessForInputValuesApi.updateBusinessForInputValuesPost(
        updateBusinessForInputValuesRequest,
        gzipRequestOptions
      );
      switch (apiResponse.status) {
        case 200:
          if (apiResponse.data.statusCode === 202) {
            const asyncResult = apiResponse.data.result as unknown as { requestId?: string };
            if (!asyncResult.requestId) {
              throw new Error('非同期レスポンスにrequestIdが含まれていません');
            }

            const pollingResult = await pollAsyncProcess<UpdateBusinessForInputValuesResponseResult>(asyncResult.requestId, {
              actionType: 'update-business-for-input-values',
            });

            if (pollingResult.status === 'failed') {
              return {
                status: {
                  type: 'error',
                  error: {
                    statusCode: 500,
                    code: 'INTERNAL_SERVER_ERROR',
                    message: pollingResult.errorMessage ?? '入力エクセル情報更新処理が失敗しました',
                  },
                },
              };
            }

            if (!pollingResult.result) {
              return {
                status: {
                  type: 'error',
                  error: {
                    statusCode: 500,
                    code: 'INTERNAL_SERVER_ERROR',
                    message: '非同期処理の結果が取得できませんでした',
                  },
                },
              };
            }

            return { status: { type: 'success', data: pollingResult.result } };
          }

          const result: UpdateBusinessForInputValuesResponseResult = apiResponse.data['result'];
          return { status: { type: 'success', data: result } };
        default:
          throw new Error('想定外のレスポンス');
      }
    } catch (err) {
      return { status: { type: 'error', error: axiosErrorHandler(err) } };
    }
  }
}
